export default {
  prevText: 'ÐÐ°Ð·Ð°Ð´',
  nextText: 'ÐÐ¿ÐµÑÑÐ´'
};
